
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {get} from 'lodash';

import Logo from '../../../../common/svgs/Logo';

@connect(store => ({
  labels: get(store.labels, 'Common', {}),
}))
export default class NavColumn extends Component {
  
  static propTypes = {
    labels: PropTypes.object.isRequired,
  }

  render() {
    return (
      <div className='applicant-nav-column'>
        <a href={this.props.labels.website}>
          <Logo className='logo'/>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/f_NavColumn/index.js